import { AdminAttendanceRequestsLoading } from '@/views/admin-attendance-requests/admin-attendance-requests.loading';

export default AdminAttendanceRequestsLoading;
